import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getClass } from 'Store/reducers';
import { showConfirmationDialog } from 'Store/ui/actions';
import { clearAllListMessages } from 'Store/lists/actions';

import UsersListAction from 'Components/UsersListAction';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class RemoveStudentFromClassAction extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.groupId !== nextProps.groupId ||
      this.props.user.id !== nextProps.user.id ||
      this.props.className !== nextProps.className
    );
  }

  handleClick() {
    const { user, className, groupId } = this.props;
    this.props.clearAllListMessages();
    this.props.showConfirmationDialog('removeStudentFromClass', {
      title: (
        <ConnectedFormattedMessage
          id="users_list.remove_student_dialog.title"
          values={{ given_name: user.given_name }}
        />
      ),
      question: (
        <ConnectedFormattedMessage
          id="users_list.remove_student_dialog.dialog_question"
          values={{ given_name: user.given_name, class_name: className }}
        />
      ),
      trueLabel: (
        <ConnectedFormattedMessage id="users_list.remove_student_dialog.true_label" />
      ),
      falseLabel: (
        <ConnectedFormattedMessage id="users_list.remove_student_dialog.false_label" />
      ),
      clearOnFalse: true,
      data: {
        userId: user.id,
        classId: groupId,
      },
    });
  }

  render() {
    const labelId = 'removeStudentFromClass';
    return (
      <UsersListAction
        label={
          <ConnectedFormattedMessage
            id={`users_list.action_labels.${labelId}`}
          />
        }
        iconType="trash"
        isRequesting={false}
        handleClick={this.handleClick}
      />
    );
  }
}

RemoveStudentFromClassAction.propTypes = {
  user: PropTypes.object,
  groupId: PropTypes.number,
  className: PropTypes.string,
  clearAllListMessages: PropTypes.func,
  showConfirmationDialog: PropTypes.func,
};

const mapStateToProps = (state, { groupId }) => {
  const _class = getClass(state, groupId);
  return {
    className: _class.name,
  };
};

export default connect(mapStateToProps, {
  showConfirmationDialog,
  clearAllListMessages,
})(RemoveStudentFromClassAction);
